// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
// Container imports
const useResizeHeightListener = require('./hooks/resize-height')
const TopCallToActionSplitLeading = require('./components/split-leading')
const TopCallToActionSplitTrailing = require('./components/split-trailing-smart')

const bem = BemEntity('TopCallToAction')

function TopCallToAction(props) {
  return tag('div', {
    ref: useResizeHeightListener(props.onFoldHeightChange),
    className: bem.block()
  },
    tag(TopCallToActionSplitLeading, {
      className: bem.element('split', 'leading'),
      forwardedRef: props.forwardedRef
    }),
    tag(TopCallToActionSplitTrailing, {
      className: bem.element('split', 'trailing')
    })
  )
}

module.exports = TopCallToAction
